/* ToolForge3D — Theme JavaScript */

// ── Helpers (module-level, beschikbaar voor alle init-functies) ──
const euro  = (cents) => (cents / 100).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' });
const esc   = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;' }[c]));
const sized = (url, w) => !url ? '' : (url.indexOf('?') === -1 ? url + '?width=' + w : url + '&width=' + w);

// ── ESC-toets: één listener, nooit herstapeld bij shopify:section:load ──
let _closeSearch     = () => {};
let _closeCartDrawer = () => {};
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') { _closeSearch(); _closeCartDrawer(); }
});

// ── Cart-tellers bijwerken (header, floating cart, mobiel menu) ──
async function updateCartCount() {
  try {
    const res  = await fetch('/cart.js');
    const cart = await res.json();
    document.querySelectorAll('#cart-count, .float-badge').forEach(el => {
      el.textContent = cart.item_count;
    });
    document.querySelectorAll('.cart-pill, .cart-pill-mobile').forEach(el => {
      el.textContent = `🛒 Winkelwagen (${cart.item_count})`;
      if (el.hasAttribute('aria-label')) {
        el.setAttribute('aria-label', `Winkelwagen, ${cart.item_count} items`);
      }
    });
  } catch (e) {}
}

// ── Scroll reveal (per section herbruikbaar) ──
function initScrollReveal(scope) {
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e, i) => {
      if (e.isIntersecting) {
        setTimeout(() => e.target.classList.add('visible'), i * 80);
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.08 });
  scope.querySelectorAll('.fade-up').forEach(el => io.observe(el));
}

// ── AJAX add-to-cart (per section herbruikbaar) ──
function initAddToCart(scope) {
  scope.querySelectorAll('form[action*="cart/add"]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('button[type=submit]');
      if (!btn || btn.disabled) return;
      const originalText = btn.textContent;
      btn.textContent = 'Toevoegen...';
      btn.disabled = true;
      try {
        const data = new FormData(form);
        const res  = await fetch('/cart/add.js', { method: 'POST', body: data });
        if (!res.ok) throw new Error('Cart add failed');
        await updateCartCount();
        document.dispatchEvent(new CustomEvent('cart:added', { detail: { opener: btn } }));
        btn.textContent = '✓ Toegevoegd!';
        setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 1500);
      } catch (err) {
        form.submit();
      }
    });
  });
}

// ── Progress bars (per section herbruikbaar) ──
function initProgressBars(scope) {
  const progObs = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.querySelectorAll('.prog-fill').forEach(b => {
          const w = b.getAttribute('data-width') || b.style.width;
          b.style.width = '0';
          requestAnimationFrame(() => { b.style.width = w; });
        });
        progObs.unobserve(e.target);
      }
    });
  });
  scope.querySelectorAll('.prog-bar').forEach(el => progObs.observe(el));
}

// ── Mobile menu (globaal, één keer) ──
function initMobileMenu() {
  const menuBtn    = document.querySelector('.mobile-menu-btn');
  const mobileMenu = document.getElementById('mobile-menu');
  if (!menuBtn || !mobileMenu) return;
  menuBtn.addEventListener('click', () => {
    const open = mobileMenu.classList.toggle('open');
    menuBtn.setAttribute('aria-expanded', open);
    mobileMenu.setAttribute('aria-hidden', !open);
  });
}

// ── Search overlay (globaal, één keer) ──
function initSearch() {
  const searchBtn     = document.querySelector('.search-toggle');
  const searchOverlay = document.getElementById('search-overlay');
  const searchClose   = document.querySelector('.search-close');
  if (!searchBtn || !searchOverlay) return;
  let searchLastFocus = null;

  function closeSearch() {
    searchOverlay.classList.remove('open');
    searchOverlay.setAttribute('aria-hidden', 'true');
    if (searchLastFocus && typeof searchLastFocus.focus === 'function') searchLastFocus.focus();
    searchLastFocus = null;
  }
  _closeSearch = closeSearch;

  searchBtn.addEventListener('click', () => {
    searchLastFocus = document.activeElement;
    searchOverlay.classList.add('open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    searchOverlay.querySelector('input')?.focus();
  });
  searchClose?.addEventListener('click', closeSearch);
  searchOverlay.addEventListener('click', e => { if (e.target === searchOverlay) closeSearch(); });
  // Focus-trap binnen de search overlay
  searchOverlay.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;
    const focusable = searchOverlay.querySelectorAll('input, button, a[href]');
    if (!focusable.length) return;
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
}

// ── Floating cart (globaal, één keer) ──
function initFloatingCart() {
  const fc = document.querySelector('.floating-cart');
  if (!fc) return;
  window.addEventListener('scroll', () => {
    fc.classList.toggle('visible', window.scrollY > 400);
  }, { passive: true });
}

// ── Cart drawer (globaal, één keer) ──
function initCartDrawer() {
  const cartDrawerRoot = document.querySelector('.cart-drawer-root');
  if (!cartDrawerRoot) return;
  const cartDrawer = cartDrawerRoot.querySelector('.cart-drawer');
  const cartBody   = document.getElementById('cart-drawer-body');
  const cartFoot   = document.getElementById('cart-drawer-foot');
  const cartTotal  = document.getElementById('cart-drawer-total');
  const shopRoot   = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

  function renderCartDrawer(cart) {
    if (!cartBody) return;
    if (!cart || cart.item_count === 0) {
      cartBody.innerHTML = '<div class="cart-drawer-empty"><div class="cart-drawer-empty-icon">🛒</div><p>Je winkelwagen is leeg.</p></div>';
      if (cartFoot) cartFoot.hidden = true;
      return;
    }
    let html = '<ul class="cart-drawer-items">';
    cart.items.forEach((item) => {
      const img = item.image
        ? '<img src="' + sized(item.image, 160) + '" alt="" width="64" height="64" loading="lazy">'
        : '<div class="cart-drawer-noimg">🔧</div>';
      const variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="cart-drawer-variant">' + esc(item.variant_title) + '</div>' : '';
      // Personalisatie tonen: properties met _ ervoor zijn intern en blijven verborgen
      let props = '';
      if (item.properties) {
        Object.keys(item.properties).forEach((k) => {
          const val = item.properties[k];
          if (!val || k.charAt(0) === '_') return;
          props += '<div class="cart-drawer-prop">' + esc(k) + ': <strong>' + esc(val) + '</strong></div>';
        });
      }
      html += '<li class="cart-drawer-item">'
        +   '<a href="' + esc(item.url) + '" class="cart-drawer-thumb">' + img + '</a>'
        +   '<div class="cart-drawer-info">'
        +     '<a href="' + esc(item.url) + '" class="cart-drawer-name">' + esc(item.product_title) + '</a>'
        +     variant
        +     props
        +     '<div class="cart-drawer-qty">'
        +       '<button type="button" class="cart-qty-btn" data-cart-action data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Minder">−</button>'
        +       '<span class="cart-qty-num">' + item.quantity + '</span>'
        +       '<button type="button" class="cart-qty-btn" data-cart-action data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Meer">+</button>'
        +     '</div>'
        +   '</div>'
        +   '<div class="cart-drawer-right">'
        +     '<button type="button" class="cart-remove-btn" data-cart-action data-key="' + item.key + '" data-qty="0" aria-label="Verwijderen">✕</button>'
        +     '<div class="cart-drawer-price">' + euro(item.final_line_price) + '</div>'
        +   '</div>'
        + '</li>';
    });
    html += '</ul>';
    cartBody.innerHTML = html;
    if (cartTotal) cartTotal.textContent = euro(cart.total_price);
    renderShipping(cart);
    if (cartFoot) cartFoot.hidden = false;
  }

  function renderShipping(cart) {
    const shipEl    = document.getElementById('cart-drawer-ship');
    const shipMsg   = document.getElementById('cart-drawer-ship-msg');
    const shipFill  = document.getElementById('cart-drawer-ship-fill');
    const threshold = parseInt(cartDrawerRoot.getAttribute('data-free-shipping-cents'), 10) || 0;
    if (!shipEl || !shipMsg || !shipFill || threshold <= 0) { if (shipEl) shipEl.hidden = true; return; }
    shipEl.hidden = false;
    if (cart.total_price >= threshold) {
      shipMsg.innerHTML = 'Je hebt <strong>gratis verzending</strong>!';
      shipFill.style.width = '100%';
    } else {
      shipMsg.innerHTML = 'Nog <strong>' + euro(threshold - cart.total_price) + '</strong> tot gratis verzending';
      shipFill.style.width = Math.min(100, (cart.total_price / threshold) * 100) + '%';
    }
  }

  async function fetchAndRenderCart() {
    try {
      const res = await fetch(shopRoot + 'cart.js', { headers: { 'Accept': 'application/json' } });
      renderCartDrawer(await res.json());
    } catch (e) {}
  }

  async function changeCartLine(key, quantity) {
    const res = await fetch(shopRoot + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
    if (!res.ok) throw new Error('cart change failed');
    return res.json();
  }

  const cartCloseBtn = cartDrawerRoot.querySelector('.cart-drawer-close');
  let lastFocused = null;

  function openCartDrawer(opener) {
    lastFocused = opener || document.activeElement;
    document.getElementById('mobile-menu')?.classList.remove('open');
    cartDrawerRoot.classList.add('open');
    if (cartDrawer) {
      cartDrawer.removeAttribute('inert');
      cartDrawer.setAttribute('aria-hidden', 'false');
    }
    document.body.classList.add('cart-drawer-locked');
    fetchAndRenderCart();
    if (cartCloseBtn) cartCloseBtn.focus();
  }

  function closeCartDrawer() {
    if (!cartDrawerRoot.classList.contains('open')) return;
    cartDrawerRoot.classList.remove('open');
    if (cartDrawer) {
      cartDrawer.setAttribute('inert', '');
      cartDrawer.setAttribute('aria-hidden', 'true');
    }
    document.body.classList.remove('cart-drawer-locked');
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    lastFocused = null;
  }
  _closeCartDrawer = closeCartDrawer;

  // Focus-trap binnen de cart drawer
  if (cartDrawer) {
    cartDrawer.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;
      const f = cartDrawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  // Open via header-cart, mobiele cart en floating cart
  document.querySelectorAll('.cart-pill, .cart-pill-mobile, .float-btn').forEach((link) => {
    link.addEventListener('click', (e) => { e.preventDefault(); openCartDrawer(e.currentTarget); });
  });
  // Sluiten via sluitknop, overlay en "Verder winkelen"
  cartDrawerRoot.querySelectorAll('[data-cart-close]').forEach((el) => el.addEventListener('click', closeCartDrawer));

  // Aantal wijzigen / verwijderen
  let cartBusy = false;
  if (cartBody) {
    cartBody.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-cart-action]');
      if (!btn || cartBusy) return;
      cartBusy = true;
      cartBody.classList.add('is-busy');
      try {
        const cart = await changeCartLine(btn.getAttribute('data-key'), parseInt(btn.getAttribute('data-qty'), 10));
        renderCartDrawer(cart);
        updateCartCount();
      } catch (err) {
        fetchAndRenderCart();
      } finally {
        cartBody.classList.remove('is-busy');
        cartBusy = false;
      }
    });
  }

  // Open drawer automatisch na succesvolle add-to-cart
  document.addEventListener('cart:added', (e) => openCartDrawer(e.detail && e.detail.opener));
}

// ── Per-section init: heruitvoerbaar bij shopify:section:load ──
function initSection(scope) {
  initScrollReveal(scope);
  initAddToCart(scope);
  initProgressBars(scope);
}

// ── Boot ──
document.addEventListener('DOMContentLoaded', () => {
  initFloatingCart();
  initMobileMenu();
  initSearch();
  initCartDrawer();
  initSection(document);
});

// OS2: herinitialiseer section-gebonden logica bij elke section reload in de Theme Editor
document.addEventListener('shopify:section:load', (e) => {
  initSection(e.target);
});
